import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import TogglerCheckbox from 'modules/core/components/Inputs/TogglerCheckbox'
import i18n from 'modules/core/lib/i18n'

import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'
import { OPERATORS } from 'modules/reports/lib/Constants'
import { VARIABLE_TYPES } from 'modules/reports/store/models/Dashboard'

const onChangeNumber = (form: ArgumentForm) => {
  return (field: Field) => {
    const value = field.value.replace(/[^0-9]/g, '')
    form.setValues({
      value,
    })
  }
}

const itemLabel = (operator: string, label: string, index: number): string => {
  if (operator !== OPERATORS.between) return label

  return i18n.t('custom_reports.date_filter_arguments_labels.value_x', {
    count: index + 1,
  })
}

const Item = ({
  operator,
  label,
  form,
  index,
  variables = [],
  onToggleNestedPopover,
}: {
  operator: string
  label: string
  form: ArgumentForm
  index: number
  variables: Array<{
    name: string
    type: any
  }>
  onToggleNestedPopover: (open: boolean) => void
}) => {
  const useVariable = !!form.get('use_variable').value

  if (operator.match(/^last_/)) {
    return <Text onChange={onChangeNumber(form)} label={label} field={form.get('value')} />
  }

  const variableOptions = variables
    .filter((variable) => variable.type === VARIABLE_TYPES.date)
    .map((variable) => ({
      label: variable.name,
      value: variable.name,
    }))

  return (
    <Box
      flexDirection="column"
      gap="s8"
      background="grey200"
      padding="s24"
      borderRadius={{
        all: 'abs008',
      }}
    >
      {!useVariable && (
        <DayPicker
          label={itemLabel(operator, label, index)}
          field={form.get('value')}
          onToggle={onToggleNestedPopover}
        />
      )}
      {useVariable && (
        <Select
          none={i18n.t('custom_reports.fields.filter_condition_none')}
          label={itemLabel(operator, label, index)}
          field={form.get('value')}
          options={variableOptions}
        />
      )}

      {!!variableOptions.length && (
        <TogglerCheckbox
          label={i18n.t('custom_reports.use_dashboard_filters')}
          field={form.get('use_variable')}
        />
      )}
    </Box>
  )
}

export default observer(Item)
